import axios from "axios";
import axiosRetry from "axios-retry";

import { ADDRESSCLOUD_ENV } from "../constants";

axiosRetry(axios, {
    retries: 3,
    retryDelay: axiosRetry.exponentialDelay,
    retryCondition: (error) =>
        !error.response ||
        axiosRetry.isNetworkOrIdempotentRequestError(error) ||
        error.response.status === 429 ||
        error.response.status === 504,
});

export default class NathanApi {
    headers;

    constructor(apiKey, clientId, userId) {
        this.headers = {
            "x-api-key": apiKey,
            "x-client-id": clientId,
            "x-user-id": userId,
        };
    }

    async post(locations) {
        const resp = await axios.post(
            `https://${ADDRESSCLOUD_ENV}.addresscloud.com/intel/v1/proxy/nathan`,
            locations,
            {
                headers: this.headers,
            }
        );
        return resp.data;
    }
}
